import { create } from 'zustand';

// ── MRU (Most Recently Used) Persistence ─────────────────────────
const MRU_KEY = 'amplione-palette-mru';
const MRU_MAX = 5;

function loadMru() {
  try {
    const raw = localStorage.getItem(MRU_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MRU_MAX) : [];
  } catch {
    return [];
  }
}

function saveMru(ids) {
  try {
    localStorage.setItem(MRU_KEY, JSON.stringify(ids.slice(0, MRU_MAX)));
  } catch {
    // quota / private mode — silent
  }
}

/**
 * Globaler Store fuer die Command-Palette.
 * Steuert Open-/Close-State, Query, Highlight-Index, MRU und den
 * optionalen "g→letter"-Chord-Modus (Leader-Key).
 */
const useCommandPaletteStore = create((set, get) => ({
  open: false,
  query: '',
  highlightIndex: 0,
  mru: loadMru(),

  // "g"-Leader fuer Schnellnavigation (g d → Dashboard, g k → Keywords, …)
  leaderActive: false,
  leaderTimeoutId: null,

  // ── Open / Close ─────────────────────────────
  openPalette: () => set({ open: true, query: '', highlightIndex: 0 }),
  closePalette: () => set({ open: false, query: '', highlightIndex: 0 }),
  togglePalette: () => {
    const { open } = get();
    if (open) get().closePalette();
    else get().openPalette();
  },

  // ── Query + Highlight ────────────────────────
  setQuery: (q) => set({ query: q, highlightIndex: 0 }),
  setHighlightIndex: (i) => set({ highlightIndex: i }),
  moveHighlight: (delta, max) => {
    const { highlightIndex } = get();
    if (max <= 0) return;
    const next = (highlightIndex + delta + max) % max;
    set({ highlightIndex: next });
  },

  // ── MRU ──────────────────────────────────────
  pushMru: (id) => {
    if (!id) return;
    const { mru } = get();
    const next = [id, ...mru.filter((x) => x !== id)].slice(0, MRU_MAX);
    saveMru(next);
    set({ mru: next });
  },
  clearMru: () => {
    saveMru([]);
    set({ mru: [] });
  },

  // ── Leader (g→letter) ────────────────────────
  startLeader: () => {
    const { leaderTimeoutId } = get();
    if (leaderTimeoutId) clearTimeout(leaderTimeoutId);
    const id = setTimeout(() => set({ leaderActive: false, leaderTimeoutId: null }), 1500);
    set({ leaderActive: true, leaderTimeoutId: id });
  },
  stopLeader: () => {
    const { leaderTimeoutId } = get();
    if (leaderTimeoutId) clearTimeout(leaderTimeoutId);
    set({ leaderActive: false, leaderTimeoutId: null });
  },
}));

export default useCommandPaletteStore;
